import { AxiosResponse } from "axios";
import axios, { configHeader, getHeaders } from "./axios";

export interface CategoryBody {
  name: string;
  categoryFor: string;
}

export interface CategoryResponse {
  name: string;
  id: number;
  categoryFor: string;
  isAvailable: string;
}

export type AllCategory = Category[];
export type AllMenuCategory = Menu[];

export interface Category {
  id: number;
  name: string;
  categoryFor: "cafe" | "bar" | "dessert";
  isAvailable: "available" | "unavailable";
  menus: Menu[];
}

export interface Menu {
  id: number;
  name: string;
  createdAt: string;
  isActive: "active" | "inactive";
  isAvailable: "available" | "unavailable";
  description: string;
  image?: string | null;
  imageFileId?: string | null;
  availableDays?: number[] | null;
  availableFromMin?: number | null;
  availableToMin?: number | null;
  category: CategoryResponse;
}

export const postCategory = async (
  body: CategoryBody
): Promise<CategoryResponse> => {
  const headers = configHeader();
  const menuSucces = await axios.post<CategoryResponse>(
    `/category`,
    body,
    headers
  );
  return menuSucces.data;
};

export const getAllCatagory = async (): Promise<AllCategory> => {
  const headers = getHeaders();
  const response: AxiosResponse<AllCategory> = await axios.get(
    "/category",
    headers
  );
  return response.data;
};

export const getCatagoryByID = async (id: number): Promise<Category> => {
  const headers = getHeaders();
  const response = await axios.get(`/category/${id}`, headers);
  return response.data;
};

export interface PatchCategoryByID {
  isAvailable: string;
  name: string;
  categoryFor: string;
}

export interface CategoryByIDResponse {
  id: number;
  name: string;
  isAvailable: string;
}

export const patchCategoryByID = async (
  id: number,
  body: PatchCategoryByID
): Promise<CategoryByIDResponse> => {
  const headers = getHeaders();
  const response = await axios.patch<CategoryByIDResponse>(
    `/category/${id}`,
    body,
    headers
  );
  return response.data;
};
export const patchSoftDeleteCategoryByID = async (category_id :number): Promise<CategoryResponse> => {
  const headers = getHeaders();
  const response = await axios.patch<CategoryResponse>(`/category/${category_id}/unavailable`,null, headers);
  return response.data;
}
